import { render, staticRenderFns } from "./BottonmMenu4.vue?vue&type=template&id=9370a192"
import script from "./BottonmMenu4.vue?vue&type=script&lang=js"
export * from "./BottonmMenu4.vue?vue&type=script&lang=js"
import style0 from "./BottonmMenu4.vue?vue&type=style&index=0&id=9370a192&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports